import * as prand from './pure-rand-default';
export default prand;
export * from './pure-rand-default';
